import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import BugReportIcon from "@mui/icons-material/BugReport";
import api from "../../../axiosconfig.js";
import { logout } from "../../../store/authSlice";
import { openBugReport } from "../../../store/bugReportSlice";
import Icon from "../../../assets/Icon.svg";
import Chat from "../../../assets/Chat.svg";
import Mindfulness from "../../../assets/Mindfullness.svg";
import Live from "../../../assets/Live.svg";
import Checkin from "../../../assets/Checkin.svg";
import Logout from "../../../assets/Logout.svg";
import "./SidebarMobile.css";
import { selectProfileImageUrl } from "../../../store/profileImageSlice.js";
import { isAdminUser } from "../../../utils/userUtils";

export const MobileSidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const avatarUrl = useSelector(selectProfileImageUrl);
  const user = useSelector((s) => s.auth.user);
  const isAdmin = isAdminUser(user);
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL;

  const handleLogout = async () => {
    console.log("logout");
    try {
      await api.post(`${API_URL}/login`, { request: "logout" });

      // Dispatch logout action to clear Redux state
      dispatch(logout());

      localStorage.removeItem("completedAssessmentTabs");
      localStorage.removeItem("progress");

      navigate("/");

      console.log("logout complete");
    } catch (error) {
      console.log("Logout failed: ", error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isActive = (path) => location.pathname === path;

  const handleClose = async () => {
    if (onClose) {
      onClose();
    }
    const el = document.getElementById("sidebar");
    if (el) el.style.display = "none";
  };

  return (
    <div className="sidebar-Expanded" id="sidebar">
      <div className="mindsherpa-logo-mobile">
        <div className="frame-mobile" onClick={() => navigate("/home")} style={{ cursor: 'pointer' }}>
          <img className="icon" src={Icon} alt="mindsherpa-logo" />
          <p className="frame-mobile-text">mindsherpa</p>
        </div>
        <div className="sidebar-back-icon" onClick={handleClose}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      </div>
      <div
        className={`home-mobilesidebar ${isActive("/user-statistics") ? "active" : ""}`}
        onClick={() => navigate("/user-statistics")}
      >
        <span className="home-mobile" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            focusable="false"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M1.75 13.25V1.5H.5v12a1.24 1.24 0 0 0 1.22 1H15.5v-1.25z"
            />
            <path
              fill="currentColor"
              d="M3.15 8H4.4v3.9H3.15zm3.26-4h1.26v7.9H6.41zm3.27 2h1.25v5.9H9.68zm3.27-3.5h1.25v9.4h-1.25z"
            />
          </svg>
        </span>
        <p className="text-home">User stats</p>
      </div>
      <hr className="line-mobile" />

      {/* Main Navigation */}
      <div className="main-part-mobile">
        <div
          className={`menu-item-mobile ${
            isActive("/assessment-dashboard") ||
            isActive("/Disclaimer") ||
            isActive("/Assessment/maincontent") ||
            isActive("/Question-card") ||
            isActive("/PEARLIReports")
              ? "active"
              : ""
          }`}
          onClick={() => navigate("/assessment-dashboard")}
        >
          <img className="menu-icon-mobile" src={Checkin} alt="assessment" />
          <p className="menu-text-mobile">Assessment</p>
        </div>
        <div
          className={`menu-item-mobile ${
            isActive("/sherpa-dashboard") || isActive("/sherpa") ? "active" : ""
          }`}
          onClick={() => {
            handleClose();
            navigate("/sherpa");
          }}
        >
          <img className="sherpa-icon-mobile" src={Chat} alt="Sherpa" />
          <p className="menu-text-mobile">Sherpa</p>
        </div>
        <div
          className={`menu-item-mobile ${
            isActive("/mindfulness") || isActive("/exercises") ? "active" : ""
          }`}
          onClick={() => navigate("/mindfulness")}
        >
          <img
            className="menu-icon-mobile"
            src={Mindfulness}
            alt="mindfulness"
          />
          <p className="menu-text-mobile">Mindfulness</p>
        </div>
        <div
          className={`menu-item-mobile ${isActive("/live") ? "active" : ""}`}
          onClick={() => navigate("/live")}
        >
          <img className="menu-icon-mobile" src={Live} alt="live" />
          <p className="menu-text-mobile">Live</p>
        </div>

        <div
          className={`menu-item-mobile ${isActive("/courses") ? "active" : ""}`}
          onClick={() => navigate("/courses")}
        >
          <FontAwesomeIcon
            className="admin-icon-mobile"
            icon={faGraduationCap}
            alt="courses"
          />
          <p className="menu-text-mobile">Courses</p>
        </div>
      </div>

      <hr className="line-mobile" />
      {/* Footer: Profile & Logout */}
      <div className="logout-area-mobile">
        {isAdmin ? (
          <div
            className={`admin-mobile ${isActive("/admin") ? "active" : ""}`}
            onClick={() => navigate("/admin")}
          >
            <FontAwesomeIcon
              className="admin-icon-mobile"
              icon={faKey}
              alt="admin"
            />
            <p className="admin-text-mobile">Admin Portal</p>
          </div>
        ) : (
          ""
        )}
        {user?.role === "Developer" && (
          <div
            className={`menu-item-mobile ${isActive("/dev") ? "active" : ""}`}
            onClick={() => navigate("/dev")}
          >
            <AnalyticsOutlinedIcon className="menu-icon-mui-mobile" />
            <p className="menu-text-mobile">Dev Portal</p>
          </div>
        )}
        <div
          className={`profile-mobile ${isActive("/profile") ? "active" : ""}`}
          onClick={() => navigate("/profile")}
        >
          <img
            className="profile-icon"
            alt="Profile"
            src={avatarUrl || "/pro.png"}
            onError={(e) => {
              const img = e.currentTarget;
              img.onerror = null;
              img.src = "/pro.png";
            }}
          />
          <p className="profile-text-mobile">Profile</p>
        </div>
        <div
          className={`logout-mobile ${isActive("/logout") ? "active" : ""}`}
          onClick={() => handleLogout()}
        >
          <img className="logout-icon-mobile" src={Logout} alt="logout" />
          <p className="logout-text-mobile">Logout</p>
        </div>
        <div
          className="bug-report-mobile"
          onClick={() => {
            handleClose();
            dispatch(openBugReport());
          }}
        >
          <div className="bug-icon-mobile-wrapper">
            <BugReportIcon className="bug-icon-mobile" />
          </div>
          <p className="bug-report-text-mobile">Report Bug</p>
        </div>
      </div>
    </div>
  );
};
